import styled from 'styled-components';

const RatingStyle = styled.div`
	--starSize: var(--sp3x);
	--componentItemGap: var(--sp1-5x);

	svg {
		width: var(--starSize);
		height: var(--starSize);
	}

	.flex {
		display: flex;
		gap: var(--sp0-5x);
	}

	.relative-star {
		position: relative;
		width: var(--starSize);
		height: var(--starSize);
	}

	.absolute-star {
		position: absolute;
		top: 0;
		left: 0;
		width: calc(var(--starSize) / 2);
		height: var(--starSize);
		overflow: hidden;
	}

	.wrapper-starts-text {
		display: flex;
		gap: var(--componentItemGap);
	}

	.color-main {
		path {
			fill: var(--mainColor);
		}
	}

	.back-color {
		path {
			fill: var(--neutral500);
		}
	}

	&.color-reverse {
		.color-main {
			path {
				fill: var(--pink1000);
			}
		}
	}

	.color-hover {
		transition: color var(--trTime) ease-out;

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					color: var(--pink1000);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--starSize: var(--sp2-5x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;
export default RatingStyle;
